import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "item",
    staticStyle: {
      "height": "100%",
      "background-color": "#ffffff"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Q:" + _vm._s(_vm.info.name))]), _c('div', {
    staticClass: "extra"
  }, [_vm.$showUserName(_vm.info.update_name) ? _c('span', [_vm._v(i18n.tc("460") + _vm._s(_vm.info.update_name))]) : _vm._e(), _vm._v(" \xA0\xA0\xA0\xA0" + i18n.tc("461") + _vm._s(_vm.info.update_time) + " ")]), _c('div', {
    staticClass: "content",
    staticStyle: {
      "white-space": "pre-line"
    }
  }, [_vm._v("A:" + _vm._s(_vm.info.answer))]), _c('div', {
    staticClass: "star"
  }, [_c('div', {
    class: _vm.info.is_like === 1 ? 'star-item-selected' : 'star-item',
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": _vm.zan
    }
  }, [_c('img', {
    staticClass: "img_zan"
  }), _vm._v("    "), _c('div', [_vm._v(_vm._s(_vm.info.up_num))])]), _vm._v("      "), _c('div', {
    class: _vm.info.is_like === 0 ? 'star-item-selected' : 'star-item',
    on: {
      "click": _vm.cai
    }
  }, [_c('img', {
    staticClass: "img_cai"
  }), _vm._v("    "), _c('div', [_vm._v(_vm._s(_vm.info.down_num))])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };